import axios from "axios";
import authHeader from "./auth-header";
import { toast } from "react-toastify";

export const fetchAllSchemeMasters = (filter) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${process.env.REACT_APP_BASE_URL}/schememaster`, {
        headers: authHeader(),
        params: filter,
      })
      .then((res) => {
        return resolve(res.data.data);
      })
      .catch((err) => {
        if (err?.response?.data?.msg) toast.error(err?.response?.data?.msg);
        return reject(err);
      });
  });
};

export const generateSchemeEligibilitySummary = (data) => {
  return axios
    .post(
      `${process.env.REACT_APP_BASE_URL}/schememaster/report/eligibility-summary`,
      data,
      {
        headers: authHeader(),
      }
    )
    .then((res) => {
      return res.data.data;
    });
};


export const fetchOneSchemeMaster = (id) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${process.env.REACT_APP_BASE_URL}/schememaster/${id}`, {
        headers: authHeader(),
      })
      .then((res) => {
        return resolve(res.data.data);
      })
      .catch((err) => {
        if (err?.response?.data?.msg) toast.error(err?.response?.data?.msg);
        return reject(err);
      });
  });
};

export const createSchemeMaster = (data) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`${process.env.REACT_APP_BASE_URL}/schememaster`, data, {
        headers: authHeader(),
      })
      .then((res) => {
        toast.success(res.data.msg);
        return resolve(res.data.data);
      })
      .catch((err) => {
        if (err?.response?.data?.msg) toast.error(err?.response?.data?.msg);
        return reject(err);
      });
  });
};

export const updateSchemeMaster = (data, id) => {
  return new Promise((resolve, reject) => {
    axios
      .put(`${process.env.REACT_APP_BASE_URL}/schememaster/${id}`, data, {
        headers: authHeader(),
      })
      .then((res) => {
        toast.success(res.data.msg);
        return resolve(res.data.data);
      })
      .catch((err) => {
        if (err?.response?.data?.msg) toast.error(err?.response?.data?.msg);
        return reject(err);
      });
  });
};

export const deleteSchemeMaster = (id) => {
  return new Promise((resolve, reject) => {
    axios
      .delete(`${process.env.REACT_APP_BASE_URL}/schememaster/${id}`, {
        headers: authHeader(),
      })
      .then((res) => {
        toast.success(res.data.msg);
        return resolve(res.data.data);
      })
      .catch((err) => {
        if (err?.response?.data?.msg) toast.error(err?.response?.data?.msg);
        return reject(err);
      });
  });
};

export const generateSchemeEligibilityDetail = (data) => {
  return new Promise((resolve, reject) => {
    axios
      .post(
        `${process.env.REACT_APP_BASE_URL}/schememaster/report/eligibility-detail`,
        data,
        {
          headers: authHeader(),
        }
      )
      .then((res) => {
        return resolve(res.data.data);
      })
      .catch((err) => {
        if (err?.response?.data?.msg) toast.error(err?.response?.data?.msg);
        return reject(err);
      });
  });
};

export const generateSchemePrint = (data) => {
  return new Promise((resolve, reject) => {
    axios
      .post(
        `${process.env.REACT_APP_BASE_URL}/schememaster/report/print`,
        data,
        {
          headers: authHeader(),
        }
      )
      .then((res) => {
        return resolve(res.data.data);
      })
      .catch((err) => {
        if (err?.response?.data?.msg) toast.error(err?.response?.data?.msg);
        return reject(err);
      });
  });
};

export const generateSchemePendingOrders = (data) => {
  return new Promise((resolve, reject) => {
    axios
      .post(
        `${process.env.REACT_APP_BASE_URL}/schememaster/report/pending-orders`,
        data,
        {
          headers: authHeader(),
        }
      )
      .then((res) => {
        return resolve(res.data.data);
      })
      .catch((err) => {
        if (err?.response?.data?.msg) toast.error(err?.response?.data?.msg);
        return reject(err);
      });
  });
};
